import { createService } from '@bonanza-social/toolkit/api';
import { CashbackResponseSchema } from './CashbackService.schemas';

export default createService(
  {
    getCashback: {
      method: 'GET',
      url: '/promotions/cashback',
      responseSchema: CashbackResponseSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
